import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import ColorSvg from '../CustomColorSelector/ColorSvg';
import { CUSTOM_LIST, GRADIENT_LIST } from './content';
import { Dropdown } from 'tea-component';
import CustomColorSelector from '../CustomColorSelector';
import { CUSTOM_HEXS } from '../ColorPalette/constants';
import './index.scss';

interface IColorInfo {
  hexa: string;
  alpha: string;
}
interface IcolorTheme {
  type: string;
  id?: string;
  color: IColorInfo[];
}
interface IGradientConfig {
  id: string;
  name: string;
  color: IColorInfo[];
}
interface IGradientDropdownProps {
  className?: string;
  options?: IGradientConfig[];
  isLocal?: boolean;
  colorTheme?: IcolorTheme;
  onChange?: (config: IGradientConfig) => void;
}
interface IGradientDropdownRef {
  colorTheme: IcolorTheme;
}

const GradientDropdown = forwardRef<IGradientDropdownRef, IGradientDropdownProps>((props, ref) => {
  const { formatMessage } = useIntl();
  const { className, options = GRADIENT_LIST, isLocal = true, colorTheme, onChange } = props;

  const [selectedGradient, setSelectedGradient] = useState(colorTheme?.id ? colorTheme : options?.[0]);

  // 处理渐变色选择
  const handleGradientSelect = (config: any) => {
    setSelectedGradient(config);
    onChange?.(config);
  };

  // 暴露方法给父组件调用
  useImperativeHandle(ref, () => ({
    colorTheme: {
      type: 'gradientColor',
      id: selectedGradient?.id,
      color: selectedGradient?.color,
    }
  }));

  const [customColor, setCustomColor] = useState(selectedGradient?.id === 'custom' ? selectedGradient?.color : CUSTOM_LIST?.[0]?.color);

  const customButton = <div
    className={'dbl-gradient-item-button'}
    onClick={() => handleGradientSelect({
      id: 'custom',
      name: 'dbl_chart_map_color_custom',
      color: customColor,
    })}
  >
    <div className="dbl-gradient-item-label">
      {formatMessage({ id: "dbl_chart_map_color_custom" })}
    </div>
    <div className="dbl-gradient-item-color">
      {customColor?.map((item, index) => (
        <ColorSvg key={index} color={item?.hexa} />
      ))}
    </div>
  </div>;

  return (
    <div className={classNames('dbl-gradient-dropdown', className)}>
      <div className="dbl-gradient-dropdown-list">
        {options?.map((config) => (
          <div
            key={config?.id}
            className={classNames('dbl-gradient-item', {
              'dbl-gradient-item-active': config?.id === selectedGradient?.id,
            })}
            onClick={() => handleGradientSelect(config)}
          >
            <div className="dbl-gradient-item-label">
              {isLocal ? formatMessage({ id: config?.name }) : config?.name}
            </div>
            <div className="dbl-gradient-item-color">
              {config?.color?.map((item, index) => (
                <ColorSvg key={index} color={item?.hexa} />
              ))}
            </div>
          </div>
        ))}

        <Dropdown
          className={classNames(
            'dbl-gradient-item',
            'dbl-gradient-custom-dropdown',
            {
              'dbl-gradient-item-active': selectedGradient?.id === 'custom',
            })}
          boxClassName='dbl-gradient-custom-dropdown-box'
          clickClose={false}
          placementOffset={[0, 10]}
          button={customButton}
          appearance="link"
          placement="right-end"
          onClose={() => {
            handleGradientSelect({
              id: 'custom',
              name: 'dbl_chart_map_color_custom',
              color: customColor,
            });
          }}
        >
          <div className='dbl-gradient-custom-dropdown-content'>
            {
              customColor?.map((color, index) => (<CustomColorSelector
                key={index}
                colorInfo={color}
                presetColors={CUSTOM_HEXS}
                placementOffset={[6, 10]}
                button={<>
                  {formatMessage({ id: `dbl_chart_map_level${index + 1}` })}
                  <ColorSvg color={color?.hexa} />
                </>
                }
                onChangeColorInfo={(colorInfo: any) => {
                  setCustomColor(customColor?.map((item, i) => i === index ? colorInfo : item));
                  handleGradientSelect({
                    id: 'custom',
                    name: 'dbl_chart_map_color_custom',
                    color: customColor?.map((item, i) => i === index ? colorInfo : item),
                  });
                }}
                style={{ width: '120px' }}
                appearance="link"
                placement="right-end"
              />))
            }
          </div>
        </Dropdown>
      </div>
    </div>
  );
});

export default GradientDropdown;
